import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '32px !important',
        fontSize: '14px',
    },
    placeholder: {
        position: 'absolute',
        left: 8,
        fontSize: 14,
        color: theme.palette.text.secondary,
    },
    paper: {
        position: 'absolute',
        zIndex: 9999,
        marginTop: theme.spacing(),
        left: 0,
        right: 0,
    },
    noOptionsMessage: {
        padding: 8,
    },
    option: {
        fontSize: '12px',
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '17px',
        color: 'rgba(120, 121, 142, 1)',
    },
    placeholderText: {
        color: '#999',
        fontSize: '12px',
        fontWeight: 400,
        padding: '5px 8px 6px 8px',
        fontStyle: 'normal',
        lineHeight: '17px',
    },
    menu: {
        marginTop: '5px',
        padding: '5px',
        fontSize: '12px',
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '17px',
        color: 'rgba(120, 121, 142, 1)',
    },
}));

// For withStyles compatibility (used by the main component)
export const styles = (theme) => ({
    root: {
        minHeight: '32px !important',
        fontSize: '14px',
    },
    placeholder: {
        position: 'absolute',
        left: 8,
        fontSize: 14,
        color: theme.palette.text.secondary,
    },
    paper: {
        position: 'absolute',
        zIndex: 9999,
        marginTop: theme.spacing(),
        left: 0,
        right: 0,
    },
});
